import { Button } from '@chakra-ui/react';
import InputComponent from 'UiKit/input';
import styles from './styles.module.css';
import { Condition } from 'Component/others';

const SubmitFormButton = ({ text, width, height, isLoading, isValid, 'data-testid': testId }) => {
  return (
    <Button
      className={styles['submit-form-button__container']}
      width={width}
      height={height}
      isLoading={isLoading}
      disabled={!isValid || isLoading}
      data-testid={testId}
    >
      {text}
      <Condition statement={isValid && !isLoading}>
        <InputComponent type="submit" className={styles['submit-form-input__container']} />
      </Condition>
    </Button>
  );
};

export default SubmitFormButton;
